import AllServicesBox from "../features/services/AllServicesBox"

export default function services() {

    return (
        <>
            <AllServicesBox />
        </>
    );
};
